import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useSelector } from 'react-redux';
import { QuestionLayout } from '../../components/QuestionLayout';
import { QuestionHeadingContainer } from '../QuestionHeadingContainer';
import { QuestionFooterContainer } from '../QuestionFooterContainer';
import { QuestionBodyContainer } from '../QuestionBodyContainer';
import { useApplicationContext } from '../ApplicationContext';
import { useAutoSubmitSteps, useStepsEvents } from '../../utils/hooks';
import { selectSendFeedbackSucceed } from '../../selectors/sendFeedback';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionLayoutContainer = function QuestionLayoutContainer(props) {
  useAutoSubmitSteps();
  useStepsEvents();
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  var isSendFeedbackSucceed = useSelector(selectSendFeedbackSucceed);
  var isModalLayout = layoutConfiguration.type === 'modal';
  return /*#__PURE__*/_jsx(QuestionLayout, _objectSpread({
    layoutType: layoutConfiguration.type,
    heading: !isModalLayout && !isSendFeedbackSucceed && /*#__PURE__*/_jsx(QuestionHeadingContainer, _objectSpread({}, props)),
    footer: !isModalLayout && /*#__PURE__*/_jsx(QuestionFooterContainer, _objectSpread({}, props)),
    body: /*#__PURE__*/_jsx(QuestionBodyContainer, _objectSpread({}, props))
  }, props));
};